import { useTranslation } from 'react-i18next';
import { INTAKE_SUBMISSION_STATUS } from '@/constants/intake';
import { cn } from '@/lib/utils';

export const ALL_INTAKE_STATUSES = '';

const FILTER_OPTIONS: { value: string; labelKey: string }[] = [
  { value: INTAKE_SUBMISSION_STATUS.submitted, labelKey: 'inbox.filter.awaitingReview' },
  { value: INTAKE_SUBMISSION_STATUS.returned, labelKey: 'inbox.filter.returned' },
  { value: INTAKE_SUBMISSION_STATUS.accepted, labelKey: 'inbox.filter.accepted' },
  { value: ALL_INTAKE_STATUSES, labelKey: 'inbox.filter.all' },
];

interface IntakeStatusFilterProps {
  value: string;
  onChange: (nextValue: string) => void;
}

export function IntakeStatusFilter({ value, onChange }: IntakeStatusFilterProps) {
  const { t } = useTranslation('intake');
  return (
    <div className="inline-flex flex-wrap bg-zoowhite border border-zooborder rounded-xl p-1 self-start">
      {FILTER_OPTIONS.map(function renderOption(option) {
        const isOn = value === option.value;
        return (
          <button
            key={option.labelKey}
            type="button"
            aria-pressed={isOn}
            onClick={function select() {
              onChange(option.value);
            }}
            className={cn(
              'px-4 py-2 rounded-lg text-xs font-bold transition-colors',
              isOn ? 'bg-zooprimary text-zoowhite' : 'text-zoomuted'
            )}
          >
            {t(option.labelKey)}
          </button>
        );
      })}
    </div>
  );
}
